import React, { useCallback }  from "react";
import {
	DataGridPro,
	GridColDef,
	GridColumns,
	GridToolbar,
	GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
	useGridApiRef,
} from "@mui/x-data-grid-pro";
import { transfersDataGridProps } from "./TransfersDataGrid.d";

const TransfersDataGrid: React.FC<transfersDataGridProps> = (props: transfersDataGridProps) => {
	const { 
		transfers,
	} = props;

	const apiRef = useGridApiRef();

	const columns: GridColumns = [
		{
			...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
		},
		{ field: "transferRequestId", headerName: "Request Id", width: 100, disableColumnMenu: true, resizable: false },
		{ field: "labelId", headerName: "Transfer Id", width: 100, disableColumnMenu: true, resizable: false },
		{ field: "fromLocationId", headerName: "From Location Id", width: 100, disableColumnMenu: true, resizable: false,
			renderCell: (params) => { return (<div>{params.row.fromLocation.locationId}</div>) }
		},
		{ field: "fromLocation", headerName: "From Location", width: 150, disableColumnMenu: true, resizable: false,
			renderCell: (params) => { return (<div>{params.row.fromLocation.locationName}</div>) }
		},
		{ field: "toLocationId", headerName: "To Location Id", width: 100, disableColumnMenu: true, resizable: false,
			renderCell: (params) => { return (<div>{params.row.toLocation.locationId}</div>) }
		},
		{ field: "toLocation", headerName: "To Location", width: 150, disableColumnMenu: true, resizable: false,
			renderCell: (params) => { return (<div>{params.row.toLocation.locationName}</div>) }
		},
		{ field: "status", headerName: "Status", width: 150 },
	];

	const OrderDetailsPanel = ({ row: rowProp }) => {
		const detailColumns: GridColDef[] = [
			{ field: "sku", headerName: "Sku", width: 100 },
			{ field: "model", headerName: "Model", width: 150 },
			{ field: "description", headerName: "Description", width: 250 },
			{ field: "requestedQuantity", headerName: "Requested", type: "number", width: 100 },
			{ field: "approvedQuantity", headerName: "Approved", type: "number", width: 100 },
			{ field: "inTransitQuantity", headerName: "In Transit", type: "number", width: 100 },
			{ field: "receivedQuantity", headerName: "Received", type: "number", width: 100 },

		];
		return (
			<DataGridPro
				autoHeight
				rows={rowProp.lineItems}
				columns={detailColumns}
				sx={{ borderRadius: 0, marginLeft: 2, marginTop: 1}}
				hideFooter
				columnVisibilityModel={{ id: false }}
				getRowId={(row) => `datagrid-details-${row.sku}-${row.locationId}` }
				density="compact"
			/>
		);
	};

	const getDetailPanelContent = useCallback(({ row }) => <OrderDetailsPanel row={row} />, []);
	const getDetailPanelHeight = useCallback(({ row }) => 70 + row.lineItems.length * 52, []); // 70 approx header row height, 52 approx row height

	return (
		<DataGridPro
			apiRef={apiRef}
			autoHeight
			density="standard"
			rows={transfers ?? []}
			columns={columns}
			paginationMode="client"
			rowsPerPageOptions={[25, 50, 100]}
			pagination
			// onSelectionModelChange={(i) => setRowSelection(i)}
			// selectionModel={rowSelection}
			getRowId={(row) => `${row.id}` }
			getDetailPanelHeight={getDetailPanelHeight}
			getDetailPanelContent={getDetailPanelContent}
			components={{
				Toolbar: GridToolbar,
			}}
			initialState={{
				pagination: {
					pageSize: 25,
				},
				sorting: {
					sortModel: [{ field: 'totalMovementQty', sort: 'desc' }],
				  },
			}}
		/>
	);
};

export default TransfersDataGrid;
